import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "tc-check-box",
    templateUrl: "./check-box.component.html",
    styleUrls: ["./check-box.component.scss"],
    standalone: false
})
export class CheckBoxComponent {
	@Output() valueChanged = new EventEmitter();

	@Input() checkBoxValue;
	_hasError;

	@Input() hideError = false;

	onValueChanges(value) {
		this.valueChanged.emit(value);
		this._hasError = !this.hideError ? !value : false;
	}
}
